import {
  REQUEST_ACCOUNTS_BY_SOURCEID,
  RECEIVE_ACCOUNTS_BY_SOURCEID,
  REQUEST_ACCOUNTS_BY_SOURCEID_ERROR
} from 'actions'
import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'

const reducer = createApiMiddlewareReducer({
  request: REQUEST_ACCOUNTS_BY_SOURCEID,
  failure: REQUEST_ACCOUNTS_BY_SOURCEID_ERROR,
  receive: RECEIVE_ACCOUNTS_BY_SOURCEID
})

export default function (state = {}, { type, payload = {} }) {
  // payload can be any type, includ null (https://github.com/acdlite/flux-standard-action#payload)
  // here, if payload === null, this reducer throws
  if (payload === null) return state
  const { sourceId } = payload
  switch (type) {
    case REQUEST_ACCOUNTS_BY_SOURCEID:
    case REQUEST_ACCOUNTS_BY_SOURCEID_ERROR:
    case RECEIVE_ACCOUNTS_BY_SOURCEID:
      return {
        ...state,
        [sourceId]: reducer(state[sourceId], { type, payload })
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/accounts-by-sourceid.js